import React, {
  useContext,
  useEffect
} from 'react';
import { flowRight, isNil } from 'lodash';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import withPageLoader from '../../hocs/with-page-loader/withPageLoader.hoc';
import { getObjectPropsArray } from '../../utilities/common.utilities';
import { AppContext } from '../../components/app/AppProvider.component';
import { trackNewPageLoadAction } from '../../components/app/app-state-actions.utilities';

export const SupportComponent = (): JSX.Element => {

  const {
    appState,
    appStateRef,
    setAppState
  } = useContext(AppContext);

  useEffect(() => {
    trackNewPageLoadAction({ appState, appStateRef, setAppState });
  }, []);

  const getCourseDataRows = () => {
    if (!appState.currentCourse) {
      return [];
    }

    return getObjectPropsArray(appState.currentCourse, [], '');
  };

  const getUserDataRows = () => {
    if (!appState.eolsUser) {
      return [];
    }

    return getObjectPropsArray(appState.eolsUser, [], '');
  };

  const renderRow = (row) => {
    return (
      <tr key={row.prop}
          className="c-els-table__row">
        <td className="c-els-table__cell">
          {row.prop}
        </td>
        <td className="c-els-table__cell">
          {isNil(row.val) ? null : row.val.toString()}
        </td>
      </tr>
    );
  };

  const buildVersion = window.getBuildVersion ? window.getBuildVersion() : null;

  return (
    <>
      <h1>Support</h1>

      <div className="o-els-container">
        <span>{`App Version: ${buildVersion}`}</span>
      </div>

      <div className="o-els-container">
        <h3>Course info</h3>
        <table className="c-els-table c-els-table--padding-1o2 c-els-table--vertical-dividers">
          <tbody className="c-els-table__body">
            {
              getCourseDataRows().map((row) => {
                return renderRow(row);
              })
            }
          </tbody>
        </table>
      </div>

      <div className="o-els-container">
        <h3>User info</h3>
        <table className="c-els-table c-els-table--padding-1o2 c-els-table--vertical-dividers">
          <tbody className="c-els-table__body">
            {
              getUserDataRows().map((row) => {
                return renderRow(row);
              })
            }
          </tbody>
        </table>
      </div>
    </>
  );
};

const enhance = flowRight(
  withHTMLHeadSEO({ title: 'Support' }),
  withPageLoader,
);

const Support = enhance(SupportComponent);
export default Support;
